<div class="container">
  <div class="news-list-wrapper">
    <h1 class="news-list-title">Hírek</h1>

    @if (items.isLoading()) {
      <p class="news-status" role="status">Hírek betöltése…</p>
    } @else if (items.error()) {
      <p class="news-status">
        A hírek betöltése nem sikerült.
        <button class="news-retry" type="button" (click)="items.reload()">Újratöltés</button>
      </p>
    } @else if (items.value().length === 0) {
      <p class="news-status">Jelenleg nincs megjeleníthető hír.</p>
    } @else {
      <ul class="news-list">
        @for (item of items.value(); track item.slug) {
          <li class="news-list-item">
            <!-- Egyetlen <a> fogja körbe a kártyát: így az egész kártya kattintható,
                 mégis csak egy tab-megálló, és nincs egymásba ágyazott hivatkozás. -->
            <a class="news-card" [class.news-card--no-image]="!item.image"
               [routerLink]="['/news', item.slug]">
              @if (item.image) {
                <!-- alt="" szándékos: a kép itt dekoratív, a hivatkozás nevét a cím adja. -->
                <img class="news-card-thumb" [src]="item.image" alt="" loading="lazy" />
              }
              <div class="news-card-body">
                <time class="news-card-date" [attr.datetime]="item.date">
                  {{ item.date | date: 'longDate' }}
                </time>
                <h2 class="news-card-title">{{ item.title }}</h2>
                <p class="news-card-summary">{{ item.summary }}</p>
                <span class="news-card-more" aria-hidden="true">
                  Tovább olvasom <span class="news-card-arrow">&#9654;</span>
                </span>
              </div>
            </a>
          </li>
        }
      </ul>
    }
  </div>
</div>
